import { Amplify } from 'aws-amplify';
import type { ResourcesConfig } from 'aws-amplify';
import { awsConfig } from './aws_config';

export const amplifyConfig: ResourcesConfig = {
  Auth: {
    Cognito: {
      userPoolId: awsConfig.Auth.userPoolId,
      userPoolClientId: awsConfig.Auth.userPoolWebClientId,
      identityPoolId: awsConfig.Auth.identityPoolId
    }
  },
  API: {
    GraphQL: {
      endpoint: awsConfig.API.aws_appsync_graphqlEndpoint,
      region: awsConfig.API.aws_appsync_region,
      defaultAuthMode: 'userPool'
    }
  },
  Storage: {
    S3: {
      bucket: awsConfig.Storage.AWSS3.bucket,
      region: awsConfig.Storage.AWSS3.region
    }
  }
};

Amplify.configure(amplifyConfig);
